import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../../core/services/seo.service';

interface PriceFaq {
  q: string;
  a: string;
}

@Component({
  selector: 'app-handwerker-preismodell',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './handwerker-preismodell.component.html',
  styleUrl: './handwerker-preismodell.component.scss',
})
export class HandwerkerPreismodellComponent {
  // Akkordeon-State: Index der derzeit offenen Frage (-1 = alle zu).
  // Erste Frage ist initial offen (mirroring OnePager § 5).
  readonly openIndex = signal(0);

  readonly faqs: PriceFaq[] = [
    {
      q: 'Wann fällt die Provision an?',
      a: 'Erst nach Annahme deines Angebots durch den Kunden und erfolgreichem Auftragsabschluss. Kommt kein Auftrag zustande, fällt keine Provision an.',
    },
    {
      q: 'Wer stellt die Rechnung an den Kunden?',
      a: 'Die Rechnung über deine Werkleistung wird in deinem Namen erstellt und dem Kunden elektronisch zugestellt — technisch durch Craftly im Gutschriftverfahren (§ 14 Abs. 2 UStG). Du bleibst der leistende Unternehmer; Craftly ist Vermittler.',
    },
    {
      q: 'Wie funktioniert die Provisionsrechnung?',
      a: 'Über die 15 % Vermittlungsprovision erhältst du eine separate Rechnung (B2B-Leistung von Craftly an dich) in deinem Konto und per E-Mail. Die Provision wird beim Auszahlungstransfer einbehalten — du musst nichts überweisen.',
    },
    {
      q: 'Was, wenn der Kunde widerruft oder storniert?',
      a: 'Dann erstellen wir automatisch die passenden Korrekturbelege (Storno-/Korrekturrechnung an den Kunden, Storno-Gutschrift an dich) und stornieren die zugehörige Provisionsrechnung. Bei Teilrückerstattung wird anteilig korrigiert. Der Treuhand-Betrag wird entsprechend freigegeben oder erstattet.',
    },
    {
      q: 'Was passiert bei einer Streitigkeit?',
      a: 'Meldet der Kunde innerhalb von 24 Stunden nach Fertigstellung einen Mangel, halten wir den Betrag im Treuhand-Hold. Beide Seiten können den Fall über die Plattform schildern; wir unterstützen eine gütliche Einigung (Nachbesserung, Minderung, Storno). Wir entscheiden nicht über Gewährleistungsrechte — deine gesetzlichen Rechte bleiben unberührt.',
    },
    {
      q: 'Wie ändere ich meine Bankverbindung?',
      a: 'Die Auszahlungs-IBAN wird im Stripe-Connect-Onboarding hinterlegt und dort geändert (Konto → Auszahlung). Sie ist die einzige Quelle — eine separate Eingabe an anderer Stelle entfällt.',
    },
  ];

  toggle(index: number) {
    this.openIndex.update((cur) => (cur === index ? -1 : index));
  }

  constructor() {
    inject(SeoService).apply({
      title: 'Preismodell für Handwerker · Craftly',
      description:
        '15 % Provision auf vermittelte Aufträge. Keine Lead-Gebühren, keine Grundgebühr, keine Premium-Slots. Kostenfrei anmelden.',
      path: '/handwerker/preismodell',
      type: 'article',
    });
  }
}
